import { observable, action, computed, createTransformer, reaction } from "mobx";
import {arrayToString, getByAtribute, stringToArray} from "../../../utils/formatar";
import GrupoNGFTService from "../../../services/GrupoNGFTService";
import EmpregadoService from "../../../services/EmpregadoService";
import UsuarioService from "../../../services/UsuarioService";
import _ from "lodash";

export default class GrupoNGFTStore {

    @observable grupoNGFTList;
    @observable itemSelecionado;
    @observable empregados;
    @observable usuarios;
    @observable loading;
    @observable posicoesSelecionadas;
    @observable alerta;

    constructor(modalStore) {
        this.modalStore = modalStore;
        this.grupoNGFTList = [];
        this.resetItemSelecionado();
        this.grupoNgftService = new GrupoNGFTService();
        this.empregadoService = new EmpregadoService();
        this.usuarioService = new UsuarioService();
        this.posicoesSelecionadas = [];
        this.empregadosFiltrados = [];
        this.usuariosFiltrados = [];
        this.usuarios = [];
        this.alerta = "";

        this.filtrarUsuarios = _.debounce(this._filtrarUsuariosPorNome, 1000);        
    }

    resetItemSelecionado() {
        this.itemSelecionado = {
            id: 0,
            nome: "",
            descricao: "",
            empregados: [],
            empregadoCPFs: "",
            usuarios: [],
            usuarioLogins: "",
            ativo: true
        };
    }

    carregarLista() {
        this.loading = true;

        const loadingPromises = Promise.all([
            this.grupoNgftService.list().then(response => {
                this.grupoNGFTList = response.data;
            }).catch(error => {
                console.log(error);
            })
        ]);
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }

    toggleAtivo() {
        this.itemSelecionado.ativo = !this.itemSelecionado.ativo;
    }

    setNome(value) {
        this.itemSelecionado.nome = value;
    }

    setNomeGrupoAd(value) {
        this.itemSelecionado.nomeGrupoAd = value;
    }

    setEmpregadoCPF(value) {
        this.alerta = "";
        let newDisplay = value;
        let retirados = this.getDiferenca(this.itemSelecionado.empregadoCPFs, value, true);
        let adicionados = this.getDiferenca(this.itemSelecionado.empregadoCPFs,value, false);

        if(retirados.length > 0){
            this.atualizaPosicoesProCpf(retirados, true);
        }

        if(adicionados.length > 0){
            this.atualizaPosicoesProCpf(adicionados, false);

            if(this.alerta.length > 0){
                let values = value.split(",");
                newDisplay = "";
                values.map((valor) => {
                    if(valor != adicionados[0]){
                        newDisplay = newDisplay.length > 0 ? newDisplay + "," + valor : valor;
                    }
                });
            }
        }

        this.itemSelecionado.empregadoCPFs = newDisplay;
    }

    getDiferenca(cpfAntigos, cpfNovos, isRetirada){
        let cpfA = [];
        if(cpfAntigos != undefined && cpfAntigos.length > 0){
            cpfA =  cpfAntigos.split(',');
        }

        let cpfN = [];
        if(cpfNovos != undefined && cpfNovos.length > 0){
            cpfN = cpfNovos.split(',');
        }


        let diferenca = [];

        if(isRetirada){
            cpfA.map( value => {
                if(cpfN.indexOf(value) == -1){
                    diferenca.push(value);
                }
            })
        }
        else{
            cpfN.map( value => {
                if(cpfA.length == 0 || cpfA.indexOf(value) == -1){
                    diferenca.push(value);
                }
            })
        }
        return diferenca;
    }

    atualizaPosicoesProCpf(listaParaAtualiza, isRetirada){
        listaParaAtualiza.map(valorCpfOuMatricula => {
            let empregado = null;
            
            if (valorCpfOuMatricula.length > 9) {
                empregado = this.empregadosFiltrados.filter(emp => emp.cpf == valorCpfOuMatricula);
            } else {
                empregado = this.empregadosFiltrados.filter(emp => emp.matricula && emp.matricula.toString() == valorCpfOuMatricula);
            }

            if (empregado && empregado.length > 0) {
                if (isRetirada && this.posicoesSelecionadas.length > 0) {
                    this.posicoesSelecionadas = this.posicoesSelecionadas.filter(pos => pos != empregado[0].posicao);
                } else {
                    if (this.posicoesSelecionadas.filter(pos => pos === empregado[0].posicao).length == 0) {
                        let cargoEmpregado = empregado[0].nh.toLowerCase();
                        let cargosProibidos = ["equipe", "técnico/operacional"];

                        if (cargosProibidos.includes(cargoEmpregado)){
                            this.alerta = "Só é possível associar posições de gestores";
                        } else {
                            this.posicoesSelecionadas.push(empregado[0].posicao);
                        }
                    }
                }
            }
        });
    }

    setUsuarioLogin(value) {
        this.itemSelecionado.usuarioLogins = value;
        if(value) {
            const novosLogins = value.split(",");
            if(novosLogins.length > this.usuarios.length) {
                this.usuarios.push(getByAtribute(this.usuariosFiltrados, novosLogins.slice(-1).pop(), "login"));
            } else {
                this.removeUsuarioByLogins(novosLogins);
            }
        } else {
            this.usuarios = [];
        }
    }

    removeUsuarioByLogins(logins) {
        let indexToRemove = 0;
        for(let i=0;i < this.usuarios.length; i++) {
            if(this.usuarios[i].login !== logins[i]){
                indexToRemove = i;
                break;
            }
        }
        if(indexToRemove || indexToRemove === 0) {
            this.usuarios.splice(indexToRemove, 1);
        }
    }

    setDescricao(value) {
        this.itemSelecionado.descricao = value;
    }

    setLista(value) {
        this.grupoNGFTList = value;
    }

    filtrarEmpregados(input, callback) {
        this.empregadoService.getByCPFOrMatricula(input, callback).then(response => {
            if(response && response.length > 0) {
                this.empregadosFiltrados.push(...response);
            }
            callback(null, {
                options: response.map(empregado => {
                    let valor = "";
                    let displayName = "";

                    if(empregado.matricula != null && empregado.matricula.toString().length > 0){
                        valor = empregado.matricula.toString();
                        displayName = empregado.matricula.toString() + " - " + empregado.nome;
                    }
                    else if(empregado.cpf != null && empregado.cpf.length > 0){
                        valor = empregado.cpf;
                        displayName = displayName.length > 0 ? displayName + " " + valor : empregado.nome + " - " + valor;
                    }

                    if(valor.length > 0){
                        return {value: valor, label: displayName};
                    }
                }),
                complete: false
            });
        }).catch(error => {
            callback(null, {
                options: [],
                complete: false
            });
        });
    }

    _filtrarUsuariosPorNome(input, callback) {
        let result = [];
        if(input && input.length > 1) {
            this.usuarioService.filterByName(input).then(response => {
                if(response.data && response.data.length > 0) {
                    this.usuariosFiltrados.push(...response.data);
                    this.usuariosFiltrados = _.uniqBy(this.usuariosFiltrados, 'login');
                    response.data.map(usuario => {
                        result.push({value: usuario.login, label: usuario.nome});
                    });
                }
                callback(null, {
                    options: result,
                    // CAREFUL! Only set this to true when there are no more options,
                    // or more specific queries will not be sent to the server.
                    complete: false
                });
            });
        } else {
            callback(null, {
                options: result,
                // CAREFUL! Only set this to true when there are no more options,
                // or more specific queries will not be sent to the server.
                complete: false
            });
        }
    }

    preencherModal(row) {
        this.posicoesSelecionadas = [];
        this.alerta = "";

        if (row) {
            if (row.posicoes == null) {
                this.posicoesSelecionadas = [];
            } else {
                this.posicoesSelecionadas = row.posicoes.map(pos => pos.posicao);
            }
            row.usuarioLogins = arrayToString(row.usuarios, "login", true);
            this.usuarios = row.usuarios.slice(0);
            this.itemSelecionado = Object.assign({}, row);
        } else {
            this.usuarios = [];
            this.resetItemSelecionado();
        }
    }

    editar() {
        let tabelaIndex = this.grupoNGFTList.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);

        const form = Object.assign({}, this.itemSelecionado);
        form.listaPosicoes = this.posicoesSelecionadas;
        form.usuarios = this.usuarios;

        return this.grupoNgftService.edit(form.id, form).then(response => {
            this.grupoNGFTList[tabelaIndex] = response.data;
        })
    }

    cadastrar() {
        const form = Object.assign({}, this.itemSelecionado);
        form.listaPosicoes = this.posicoesSelecionadas;
        form.usuarios = this.usuarios;

        return this.grupoNgftService.save(form).then(response => {
            this.grupoNGFTList.push(response.data);
        });
    }

    remover() {
        let tabelaIndex = this.grupoNGFTList.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        let modal = this.modalStore;

        return this.grupoNgftService.delete(this.itemSelecionado.id).then(response => {
            this.grupoNGFTList.splice(tabelaIndex, 1);
            modal.toggleModal()
        }).catch(error => {
            modal.setSubmitMensagemErro(error.response.data.message)
        });
    }

    removePosicaoValue(value){
        this.posicoesSelecionadas = this.posicoesSelecionadas.filter(pos => pos !== value);

        if (this.itemSelecionado.empregadoCPFs.length > 0){
            let empregado = this.empregadosFiltrados.filter(emp => emp.posicao === value);
            let cpfsOuMatricula = this.itemSelecionado.empregadoCPFs.split(',');

            empregado.map(emp => {
                if (emp.cpf != null) {
                    cpfsOuMatricula = cpfsOuMatricula.filter(cpf => cpf != emp.cpf);
                } else {
                    cpfsOuMatricula = cpfsOuMatricula.filter(matricula => matricula != emp.matricula);
                }
            });

            this.itemSelecionado.empregadoCPFs = "";

            cpfsOuMatricula.map(valor => {
                this.itemSelecionado.empregadoCPFs = this.itemSelecionado.empregadoCPFs.length > 0 ? this.itemSelecionado.empregadoCPFs + "," + valor: valor;
            });
        }
    }
}